export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "min_photos_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajoutez au moins 3 photos de votre produit"])},
        "register_anyway": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer quand même"])},
        "added_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le produit a été ajouté"])}
      },
      "en": {
        "min_photos_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add at least 3 photos of your product"])},
        "register_anyway": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Register anyway"])},
        "added_success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The product has been added"])}
      }
    }
  })
}
